export default __webpack_public_path__ + "static/media/impacto.153dcbfe.png";